"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeComponentName = exports.isComponent = exports.isCustomElement = void 0;
var formatting_1 = require("./formatting");
var BaseComponent_1 = require("../components/BaseComponent");
/**
 * Checks if an element is a Custom Element
 * @param element Element to check
 * @returns True if a custom element
 */
function isCustomElement(element) {
    // Any element with a hyphen that is not one of the below
    // reserved names (reserved for SVG/MathML specs) is a
    // custom element according to the spec.
    // https://stackoverflow.com/questions/22545621/do-custom-elements-require-a-dash-in-their-name/22545622#22545622
    return element.tagName.indexOf('-') > -1 && [
        'annotation-xml',
        'color-profile',
        'font-face',
        'font-face-src',
        'font-face-uri',
        'font-face-format',
        'font-face-name',
        'missing-glyph',
    ].indexOf(element.tagName.toLowerCase()) == -1;
}
exports.isCustomElement = isCustomElement;
/**
 * Checks if an element inherits from the SALVO BaseComponent
 * @param element Element to check
 * @returns True if inherits from SALVO BaseComponent
 */
function isComponent(element) {
    return element.$type == BaseComponent_1.BASE_COMPONENT_TYPE_FLAG;
}
exports.isComponent = isComponent;
/**
 * Validates a component filepath and determines the expected class name.
 * @param filepath Path to the component
 * @returns Expected class name of the component
 */
function normalizeComponentName(filepath) {
    var e_1, _a;
    // Remove './' prefix
    filepath = filepath.replace(/^\.\//, '');
    // Extract subdirectories and filename
    var _b = __read(filepath.split('/').reverse()), filename = _b[0], subDirs = _b.slice(1);
    var subdirectories = subDirs.reverse();
    // Remove file extension
    var ext = filename.match(/\.tsx?$/);
    var name = filename.replace(/\.tsx?$/, '');
    // Validate subdirectory names
    var checked = [];
    try {
        for (var subdirectories_1 = __values(subdirectories), subdirectories_1_1 = subdirectories_1.next(); !subdirectories_1_1.done; subdirectories_1_1 = subdirectories_1.next()) {
            var subdir = subdirectories_1_1.value;
            var pascalSubdir = (0, formatting_1.pascalCase)(subdir);
            if (subdir != pascalSubdir) {
                var current = __spreadArray(__spreadArray([], __read(checked), false), [subdir], false).join('/');
                var expected = __spreadArray(__spreadArray([], __read(checked), false), [pascalSubdir], false).join('/');
                throw new Error("Folder './components/".concat(current, "' should be './components/").concat(expected, "'"));
            }
            checked.push(subdir);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (subdirectories_1_1 && !subdirectories_1_1.done && (_a = subdirectories_1.return)) _a.call(subdirectories_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // Validate component filename
    var expectedNamePrefix = subdirectories.join('');
    if (name.indexOf(expectedNamePrefix) !== 0) {
        throw new Error("File './components/".concat(filepath, "' should have filename starting with '").concat(expectedNamePrefix, "'."));
    }
    var nameWithoutPrefix = name.substring(expectedNamePrefix.length);
    var expectedWithoutPrefix = (0, formatting_1.pascalCase)(nameWithoutPrefix);
    if (nameWithoutPrefix != expectedWithoutPrefix) {
        throw new Error("File './components/".concat(filepath, "' should use")
            + " filename '".concat(expectedNamePrefix).concat(expectedWithoutPrefix).concat(ext, "'."));
    }
    if (name.length < 4) {
        throw new Error("File './components/".concat(filepath, "' filename is too short."));
    }
    // Must contain two words to be a valid web component
    if ((0, formatting_1.kebabCase)(name).indexOf('-') === -1) {
        throw new Error("File './components/".concat(filepath, "' filename must contain two words be a valid component."));
    }
    return name;
}
exports.normalizeComponentName = normalizeComponentName;
//# sourceMappingURL=components.js.map